// extracted by mini-css-extract-plugin
module.exports = {"timelineList":"Activity_timelineList__i8izB","tList":"Activity_tList__M0c0I","content":"Activity_content__KKy8x","text":"Activity_text__s0KBk","date":"Activity_date__OLLrN"};